import React, { Component } from "react";
import { withAuth } from "../Auth/WithAuth";
import { authenticatedFetch } from "../../utils/apiClient";
let isMounted = false;

export default withAuth(
  class FrontPageAdmin extends Component {
    constructor(props) {
      super(props);
      this.state = {
        frontPage: {},
        postTitle: "",
        post: "",
        moreInfoPost: "",
        useMoreInfoPost: false,
        duringTitle: "",
        duringSubtitle: "",
        duringPost: "",
        overTitle: "",
        overSubtitle: "",
        overPost: "",
        editLanDate: "",
        editLanToDate: "",
        editMode: false,
        updated: Date().toLocaleString()
      };

      this.getFrontPage = this.getFrontPage.bind(this);
      this.handleChangeDate = this.handleChangeDate.bind(this);
      this.setEditMode = this.setEditMode.bind(this);
      this.handleChangeText = this.handleChangeText.bind(this);
      this.handleSaveDate = this.handleSaveDate.bind(this);
      this.handleSaveText = this.handleSaveText.bind(this);
      this.saveFrontPage = this.saveFrontPage.bind(this);
      this.toggleCheckbox = this.toggleCheckbox.bind(this);
      this.setUpdatedBy = this.setUpdatedBy.bind(this);
      this.formatDateForInput = this.formatDateForInput.bind(this);
    }

    async componentDidMount() {
      isMounted = true;
      this.getFrontPage();

      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";

      this.setState({
        frontPage: Object.assign({}, this.state.frontPage, {
          UpdatedBy: updatedBy
        })
      });
    }

    componentDidUpdate() {
      // Authentication is now handled by WithAuth HOC
    }

    componentWillUnmount() {
      isMounted = false;
    }

    async getFrontPage() {
      try {
        fetch("/api/pagedata/getFrontPage", {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            pragma: "no-cache",
            "cache-control": "no-cache"
          }
        })
          .then(response => {
            return response.json();
          })
          .then(data => {
            if (data && data.length > 0 && data[0]) {
              this.setState({ frontPage: data[0] });
              this.setState({ postTitle: data[0].postTitle });
              this.setState({ post: data[0].post });
              this.setState({ moreInfoPost: data[0].moreInfoPost });
              this.setState({ useMoreInfoPost: data[0].useMoreInfoPost });
              this.setState({ duringTitle: data[0].duringTitle });
              this.setState({ duringSubtitle: data[0].duringSubtitle });
              this.setState({ duringPost: data[0].duringPost });
              this.setState({ overTitle: data[0].overTitle });
              this.setState({ overSubtitle: data[0].overSubtitle });
              this.setState({ overPost: data[0].overPost });
              this.setState({ updated: Date().slice(16, 24) });
            } else {
              console.log('No front page data found in database');
            }
          })
          .catch(err => {
            console.log(err);
          });
      } catch (err) {
        console.log(err);
      }
    }

    async setEditMode() {
      if (this.state.editMode === false) {
        this.setState({
          editMode: true,
          editLanDate: this.state.frontPage.lanDate || "",
          editLanToDate: this.state.frontPage.lanFinishedDate || ""
        });
      } else {
        this.setState({ editMode: false });
      }
      await this.getFrontPage();
    }

    async setUpdatedBy() {
      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";

      await this.setState({
        frontPage: Object.assign({}, this.state.frontPage, {
          UpdatedBy: updatedBy
        })
      });
    }

    async saveFrontPage() {
      await this.setUpdatedBy();
      try {
        await authenticatedFetch("/api/admin/updateFrontPage", {
          method: "PUT",
          body: JSON.stringify(this.state.frontPage),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        }).then(this.getFrontPage());
      } catch (err) {
        console.log(err);
      } finally {
        this.setState({ editMode: false });
        window.scrollTo(0, 0);
      }
    }

    handleChangeDate(event) {
      let value = event.target.value;

      // Convert datetime-local format (2025-10-02T12:00) to "October 02 2025 12:00"
      if (value) {
        const date = new Date(value);
        const monthNames = [
          'January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'
        ];

        const month = monthNames[date.getMonth()];
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        value = `${month} ${day} ${year} ${hours}:${minutes}`;
      }

      if (event.target.name === "fromDate") {
        this.setState({
          editLanDate: value
        });
      } else if (event.target.name === "toDate") {
        this.setState({
          editLanToDate: value
        });
      }
    }
    async handleSaveDate(event) {
      event.preventDefault();

      if (this.state.editLanDate.length < 1) {
        await this.setState({ editLanDate: this.state.frontPage.lanDate });
      }
      if (this.state.editLanToDate.length < 1) {
        await this.setState({
          editLanToDate: this.state.frontPage.lanFinishedDate
        });
      }

      this.setState({
        frontPage: Object.assign(
          {},
          this.state.frontPage,
          { lanDate: this.state.editLanDate },
          { lanFinishedDate: this.state.editLanToDate }
        )
      });
    }

    toggleCheckbox(event) {
      this.setState({
        frontPage: Object.assign({}, this.state.frontPage, {
          useMoreInfoPost: event.target.checked
        })
      });
    }

    handleChangeText(event) {
      if (event.target.name === "mainPostTitle") {
        this.setState({
          postTitle: event.target.value,
          frontPage: Object.assign({}, this.state.frontPage, {
            postTitle: event.target.value
          })
        });
      } else if (event.target.name === "mainPost") {
        this.setState({
          post: event.target.value,
          frontPage: Object.assign({}, this.state.frontPage, {
            post: event.target.value
          })
        });
      } else if (event.target.name === "moreInfoPost") {
        this.setState({
          moreInfoPost: event.target.value,
          frontPage: Object.assign({}, this.state.frontPage, {
            moreInfoPost: event.target.value
          })
        });
      } else if (event.target.name === "duringPostTitle") {
        this.setState({
          duringTitle: event.target.value,
          frontPage: Object.assign({}, this.state.frontPage, {
            duringTitle: event.target.value
          })
        });
      } else if (event.target.name === "duringPostSubtitle") {
        this.setState({
          duringSubtitle: event.target.value,
          frontPage: Object.assign({}, this.state.frontPage, {
            duringSubtitle: event.target.value
          })
        });
      } else if (event.target.name === "duringPost") {
        this.setState({
          duringPost: event.target.value,
          frontPage: Object.assign({}, this.state.frontPage, {
            duringPost: event.target.value
          })
        });
      } else if (event.target.name === "overTitle") {
        this.setState({
          overTitle: event.target.value,
          frontPage: Object.assign({}, this.state.frontPage, {
            overTitle: event.target.value
          })
        });
      } else if (event.target.name === "overSubtitle") {
        this.setState({
          overSubtitle: event.target.value,
          frontPage: Object.assign({}, this.state.frontPage, {
            overSubtitle: event.target.value
          })
        });
      } else if (event.target.name === "overPost") {
        this.setState({
          overPost: event.target.value,
          frontPage: Object.assign({}, this.state.frontPage, {
            overPost: event.target.value
          })
        });
      }
    }

    handleSaveText(event) {
      event.preventDefault();
      if (event.target.name === "mainPostTitleButton") {
        this.setState({
          frontPage: Object.assign({}, this.state.frontPage, {
            postTitle: this.state.postTitle
          })
        });
      } else if (event.target.name === "mainPostButton") {
        this.setState({
          frontPage: Object.assign({}, this.state.frontPage, {
            post: this.state.post
          })
        });
      } else if (event.target.name === "moreInfoPostButton") {
        this.setState({
          frontPage: Object.assign({}, this.state.frontPage, {
            moreInfoPost: this.state.moreInfoPost
          })
        });
      } else if (event.target.name === "duringPostTitleButton") {
        this.setState({
          frontPage: Object.assign({}, this.state.frontPage, {
            duringTitle: this.state.duringTitle
          })
        });
      } else if (event.target.name === "duringPostSubtitleButton") {
        this.setState({
          frontPage: Object.assign({}, this.state.frontPage, {
            duringSubtitle: this.state.duringSubtitle
          })
        });
      } else if (event.target.name === "duringPostButton") {
        this.setState({
          frontPage: Object.assign({}, this.state.frontPage, {
            duringPost: this.state.duringPost
          })
        });
      } else if (event.target.name === "overPostTitleButton") {
        this.setState({
          frontPage: Object.assign({}, this.state.frontPage, {
            overTitle: this.state.overTitle
          })
        });
      } else if (event.target.name === "overPostSubtitleButton") {
        this.setState({
          frontPage: Object.assign({}, this.state.frontPage, {
            overSubtitle: this.state.overSubtitle
          })
        });
      } else if (event.target.name === "overPostButton") {
        this.setState({
          frontPage: Object.assign({}, this.state.frontPage, {
            overPost: this.state.overPost
          })
        });
      }
    }

    // Convert "October 02 2025 12:00" format to datetime-local input format "2025-10-02T12:00"
    formatDateForInput(dateString) {
      if (!dateString) return '';

      try {
        // If it's already in the correct format (YYYY-MM-DDTHH:mm), return as-is
        if (dateString.includes('T') && dateString.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/)) {
          return dateString;
        }

        // Parse the custom format "October 02 2025 12:00"
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '';

        // Format for datetime-local input (YYYY-MM-DDTHH:mm)
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
      } catch (error) {
        console.log('Error formatting date for input:', error);
        return '';
      }
    }

    render() {
      if (this.props.authenticated === null) return null;

      return (
        <div className="SignupList">
          <h1>Forsiden</h1>
          <button
            className={
              "btn btno edit  " +
              (this.state.editMode ? "btn-info" : "btn-danger")
            }
            onClick={this.setEditMode}
          >
            {this.state.editMode ? "Lås" : "Rediger"}
          </button>
          <button
            className="btn btno btn-success edit  "
            onClick={() => this.getFrontPage()}
          >
            Refresh
          </button>

          {this.state.editMode && (
            <button
              className="btn btno btn-primary edit"
              onClick={this.saveFrontPage}
              style={{ marginLeft: "10px", cursor: "pointer" }}
            >
              Lagre endringer
            </button>
          )}

          <hr />
          <h1 className="center">Countdown</h1>
          <h5 className="center">
            Timerdato: {this.state.frontPage.lanDate} -{" "}
            {this.state.frontPage.lanFinishedDate}
          </h5>
          {this.state.editMode === true && (
            <form className="dateFieldsContainer center">
              <input
                className="dateFields"
                type="datetime-local"
                name="fromDate"
                value={this.formatDateForInput(this.state.editLanDate || this.state.frontPage.lanDate)}
                onChange={this.handleChangeDate}
              />{" "}
              -
              <input
                className="dateFields"
                type="datetime-local"
                name="toDate"
                value={this.formatDateForInput(this.state.editLanToDate || this.state.frontPage.lanFinishedDate)}
                onChange={this.handleChangeDate}
              />{" "}
              <button
                className="btn btno btn-success edit  "
                onClick={this.handleSaveDate}
              >
                Endre dato
              </button>
            </form>
          )}
          <hr />
          {this.state.editMode ? (
            <div>
              <h1 className="center">Tekst fram til LAN</h1>
              <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Rediger: Standard tittel</h5>
                  <div className="card">
                    <textarea
                      name="mainPostTitle"
                      value={this.state.postTitle}
                      onChange={this.handleChangeText}
                      rows="4"
                      style={{ width: "100%", minHeight: "100px" }}
                    />
                  </div>
                </div>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Forhåndsvisning: Standard tittel</h5>
                  <div
                    className="card"
                    dangerouslySetInnerHTML={{
                      __html: this.state.postTitle
                    }}
                    style={{ minHeight: "100px" }}
                  />
                </div>
              </div>
              <hr />
            </div>
          ) : (
            <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
              <h1 className="center">Tekst fram til LAN</h1>
              <h5 className="center">Standard tittel:</h5>
              <div
                className="card"
                dangerouslySetInnerHTML={{
                  __html: this.state.frontPage.postTitle
                }}
              />
              <hr />
            </div>
          )}
          {this.state.editMode ? (
            <div>
              <div className="center" style={{ marginBottom: "20px" }}>
                <h6>Bruk "Mer informasjon kommer snart" post istedet?</h6>
                <input
                  type="checkbox"
                  defaultChecked={this.state.frontPage.useMoreInfoPost}
                  onClick={this.toggleCheckbox}
                />
              </div>
              <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Rediger: Standard post</h5>
                  <div className="card">
                    <textarea
                      name="mainPost"
                      value={this.state.post}
                      onChange={this.handleChangeText}
                      rows="8"
                      style={{ width: "100%", minHeight: "200px" }}
                    />
                  </div>
                </div>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Forhåndsvisning: Standard post</h5>
                  <div
                    className="card"
                    dangerouslySetInnerHTML={{ __html: this.state.post }}
                    style={{ minHeight: "200px" }}
                  />
                </div>
              </div>
              <hr />
            </div>
          ) : (
            <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
              <h5 className="center">Standard post:</h5>
              <div
                className="card"
                dangerouslySetInnerHTML={{ __html: this.state.frontPage.post }}
              />
              <hr />
            </div>
          )}
          {this.state.editMode ? (
            <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
              <div style={{ flex: "1" }}>
                <h5 className="center">Rediger: Mer informasjon snart post</h5>
                <div className="card">
                  <textarea
                    name="moreInfoPost"
                    value={this.state.moreInfoPost}
                    onChange={this.handleChangeText}
                    rows="8"
                    style={{ width: "100%", minHeight: "200px" }}
                  />
                </div>
              </div>
              <div style={{ flex: "1" }}>
                <h5 className="center">Forhåndsvisning: Mer informasjon snart post</h5>
                <div
                  className="card"
                  dangerouslySetInnerHTML={{
                    __html: this.state.moreInfoPost
                  }}
                  style={{ minHeight: "200px" }}
                />
              </div>
            </div>
          ) : (
            <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
              <h5 className="center">Mer informasjon snart post:</h5>
              <div
                className="card"
                dangerouslySetInnerHTML={{
                  __html: this.state.frontPage.moreInfoPost
                }}
              />
              <hr />
            </div>
          )}
          <div>
            <h1 className="center">LAN i gang tekst</h1>
            {this.state.editMode ? (
              <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Rediger: LAN i gang tittel</h5>
                  <div className="card">
                    <textarea
                      name="duringPostTitle"
                      value={this.state.duringTitle}
                      onChange={this.handleChangeText}
                      rows="4"
                      style={{ width: "100%", minHeight: "100px" }}
                    />
                  </div>
                </div>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Forhåndsvisning: LAN i gang tittel</h5>
                  <div
                    className="card"
                    dangerouslySetInnerHTML={{
                      __html: this.state.duringTitle
                    }}
                    style={{ minHeight: "100px" }}
                  />
                </div>
              </div>
            ) : (
              <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
                <h5 className="center">Lan i gang tittel:</h5>
                <div
                  className="card"
                  dangerouslySetInnerHTML={{
                    __html: this.state.frontPage.duringTitle
                  }}
                />
              </div>
            )}
            <hr />
          </div>
          {this.state.editMode ? (
            <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
              <div style={{ flex: "1" }}>
                <h5 className="center">Rediger: LAN i gang undertittel</h5>
                <div className="card">
                  <textarea
                    name="duringPostSubtitle"
                    value={this.state.duringSubtitle}
                    onChange={this.handleChangeText}
                    rows="4"
                    style={{ width: "100%", minHeight: "100px" }}
                  />
                </div>
              </div>
              <div style={{ flex: "1" }}>
                <h5 className="center">Forhåndsvisning: LAN i gang undertittel</h5>
                <div
                  className="card"
                  dangerouslySetInnerHTML={{
                    __html: this.state.duringSubtitle
                  }}
                  style={{ minHeight: "100px" }}
                />
              </div>
            </div>
          ) : (
            <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
              <h5 className="center">Lan i gang undertittel:</h5>
              <div
                className="card"
                dangerouslySetInnerHTML={{
                  __html: this.state.frontPage.duringSubtitle
                }}
              />
              <hr />
            </div>
          )}
          {this.state.editMode ? (
            <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
              <div style={{ flex: "1" }}>
                <h5 className="center">Rediger: LAN i gang post</h5>
                <div className="card">
                  <textarea
                    name="duringPost"
                    value={this.state.duringPost}
                    onChange={this.handleChangeText}
                    rows="8"
                    style={{ width: "100%", minHeight: "200px" }}
                  />
                </div>
              </div>
              <div style={{ flex: "1" }}>
                <h5 className="center">Forhåndsvisning: LAN i gang post</h5>
                <div
                  className="card"
                  dangerouslySetInnerHTML={{
                    __html: this.state.duringPost
                  }}
                  style={{ minHeight: "200px" }}
                />
              </div>
            </div>
          ) : (
            <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
              <h5 className="center">Lan i gang post:</h5>
              <div
                className="card"
                dangerouslySetInnerHTML={{
                  __html: this.state.frontPage.duringPost
                }}
              />
              <hr />
            </div>
          )}
          <div>
            <h1 className="center">LAN over tekst</h1>
            {this.state.editMode ? (
              <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Rediger: LAN over tittel</h5>
                  <div className="card">
                    <textarea
                      name="overTitle"
                      value={this.state.overTitle}
                      onChange={this.handleChangeText}
                      rows="4"
                      style={{ width: "100%", minHeight: "100px" }}
                    />
                  </div>
                </div>
                <div style={{ flex: "1" }}>
                  <h5 className="center">Forhåndsvisning: LAN over tittel</h5>
                  <div
                    className="card"
                    dangerouslySetInnerHTML={{
                      __html: this.state.overTitle
                    }}
                    style={{ minHeight: "100px" }}
                  />
                </div>
              </div>
            ) : (
              <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
                <h5 className="center">Lan over tittel:</h5>
                <div
                  className="card"
                  dangerouslySetInnerHTML={{
                    __html: this.state.frontPage.overTitle
                  }}
                />
              </div>
            )}
            <hr />
          </div>
          {this.state.editMode ? (
            <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
              <div style={{ flex: "1" }}>
                <h5 className="center">Rediger: LAN over undertittel</h5>
                <div className="card">
                  <textarea
                    name="overSubtitle"
                    value={this.state.overSubtitle}
                    onChange={this.handleChangeText}
                    rows="4"
                    style={{ width: "100%", minHeight: "100px" }}
                  />
                </div>
              </div>
              <div style={{ flex: "1" }}>
                <h5 className="center">Forhåndsvisning: LAN over undertittel</h5>
                <div
                  className="card"
                  dangerouslySetInnerHTML={{
                    __html: this.state.overSubtitle
                  }}
                  style={{ minHeight: "100px" }}
                />
              </div>
            </div>
          ) : (
            <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
              <h5 className="center">Lan over undertittel:</h5>
              <div
                className="card"
                dangerouslySetInnerHTML={{
                  __html: this.state.frontPage.overSubtitle
                }}
              />
              <hr />
            </div>
          )}
          {this.state.editMode ? (
            <div style={{ display: "flex", gap: "30px", marginBottom: "30px" }}>
              <div style={{ flex: "1" }}>
                <h5 className="center">Rediger: LAN over post</h5>
                <div className="card">
                  <textarea
                    name="overPost"
                    value={this.state.overPost}
                    onChange={this.handleChangeText}
                    rows="8"
                    style={{ width: "100%", minHeight: "200px" }}
                  />
                </div>
              </div>
              <div style={{ flex: "1" }}>
                <h5 className="center">Forhåndsvisning: LAN over post</h5>
                <div
                  className="card"
                  dangerouslySetInnerHTML={{
                    __html: this.state.overPost
                  }}
                  style={{ minHeight: "200px" }}
                />
              </div>
            </div>
          ) : (
            <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
              <h5 className="center">Lan over post:</h5>
              <div
                className="card"
                dangerouslySetInnerHTML={{
                  __html: this.state.frontPage.overPost
                }}
              />
              <hr />
            </div>
          )}

          <hr />
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Components/Admin/FrontPageAdmin.js